<template>
  <div class="quick-add-attributes">
    <button v-for="attribute in quickAddAttributes" ref="button" :key="attribute.id"
            :class="{'is-active': isActive(attribute)}"
            @click="attributeClickedHandler(attribute, $event)"
            :disabled='viewOnly'>
      {{ getPrettyName(attribute) }}
    </button>
  </div>
</template>

<script>
import { createPopover, popoverTypes } from '@/components/common/popover'
import { ADD_ATTRIBUTE } from '@/appComponents/workbench/targetDefinition/store/actions'
import attributeTypes from '@/appComponents/workbench/attributePanel/services/attributeType'
import { cloneDeep } from 'lodash'

// TODO: This is a temporary mapping of pretty names. It will need to be removed
// once the names are prettified in the dataset.
const PRETTY_NAME_MAP = {
  'headofhouseholdagebreak': 'Age',
  'homestructuretype': 'Dwelling Type',
  'headofhouseholdeducation': 'Education',
  'gender': 'Gender',
  'HasChildren': 'Has Children',
  'homeownershipstatus': 'Home Ownership',
  'householdsize': 'Household Size',
  'householdincome': 'Income'
}

export default {
  props: {
    viewOnly: Boolean
  },
  data () {
    return {
      popover: null,
      currentActiveAttribute: null
    }
  },
  computed: {
    quickAddAttributes () {
      return this.$store.getters.quickAddAttributes
    }
  },
  methods: {
    add (attribute) {
      this.$store.dispatch('workbench/' + ADD_ATTRIBUTE, attribute)
    },
    isActive (attribute) {
      return this.currentActiveAttribute === attribute
    },
    getPrettyName (attribute) {
      return PRETTY_NAME_MAP[attribute.id] ? PRETTY_NAME_MAP[attribute.id] : attribute.name
    },
    attributeClickedHandler (attribute, e) {
      if (attribute.type === attributeTypes.BOOLEAN) {
        this.add(cloneDeep(attribute))
      } else {
        this.createPopover(attribute, e)
      }
    },
    createPopover (attribute, e) {
      this.currentActiveAttribute = attribute
      this.popover = createPopover({
        direction: 'top',
        attribute: attribute,
        parent: e.target,
        root: document.getElementById('app'),
        type: popoverTypes.ATTRIBUTE
      })
      this.popover
        .$on('select', attr => {
          this.add(attr)
        })
        .$on('dismiss', () => {
          this.currentActiveAttribute = null
        })
    }
  }
}
</script>

<style lang="scss">
  .quick-add-attributes {
    display: flex;
    flex-shrink: 0;
    height: rem(50);
    border-bottom: 1px solid black;

    & button:first-child {
      border-left: none;
    }

    button {
      font-weight: bold;
      text-transform: uppercase;
      background: color(blue-black, darker);
      color: white;
      border-left: rem(1) solid color(grays, medium);
      border-right: none;
      border-bottom: rem(2) solid transparent;
      border-top: none;
      padding: rem(3) rem(24) 0;
      font-size: rem(14);
      line-height: rem(14);

      &:focus {
        outline: none;
      }

      &:hover,
      &.is-active {
        border-bottom: rem(2) solid color(yellow);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// QuickAddAttributes.vue?ae5b02b0